import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import CB1R1O from './1R1O';
import CBOW from './CBOW';
import { getUserFieldValue } from '../../../../Util/Util';

const Checkbox = (props) => {
	const { t } = useTranslation();
	const dispatch = useDispatch();

	const {form_component, formFields} = props;
	const {fieldname, options, limit_option_select, max_options, option_display, required} = form_component;

	const fv = useSelector(state => state.fv);
	const userData = useSelector(state => state.userData);
	const cbFieldData = useSelector(state => state.cbFieldData);

	let userFieldValue = getUserFieldValue(fieldname, userData);

	const checkedValues = typeof cbFieldData[fieldname] !== 'undefined' ? cbFieldData[fieldname] : [];
	const optionList = Array.isArray(options) ? options : [];
	const displayMode = option_display || '1R1O';

	const normalizeOptionValue = (val) => {
		if (val === null || val === undefined || val === '') {
			return '';
		}
		if (typeof val === 'object') {
			if (val.$oid) {
				return String(val.$oid);
			}
			if (val.oid) {
				return String(val.oid);
			}
		}
		return String(val);
	};

	useEffect(() => { // to be updated after render
		var checkbox_default_values = [];
		const selectedValues = Array.isArray(userFieldValue)
			? userFieldValue.map(normalizeOptionValue).filter(v => v !== '')
			: (userFieldValue ? [normalizeOptionValue(userFieldValue)] : []);

		optionList.forEach((option) => {
			const optionValue = normalizeOptionValue(option.value);
			if (!optionValue) {
				return;
			}
			if (option.default_select) {
				checkbox_default_values.push(optionValue);
			}
			if (selectedValues.indexOf(optionValue) >= 0 && checkbox_default_values.indexOf(optionValue) < 0) {
				checkbox_default_values.push(optionValue);
			}
		});

		const payload = {...cbFieldData};
		payload[fieldname] = checkbox_default_values;
		dispatch({type: 'SET_CBFIELD_DATA', payload: payload});
	}, []);

	useEffect(() => { // to be updated after render
		if (fv) {
			var validator = {
				validators: {}
			};

			if (required) {
				validator.validators.notEmpty = {
					message: t('此欄為必須填寫')
				};
			}

			if (limit_option_select) {
				validator.validators.choice = {
					max: max_options,
					message: t('最多可選擇 {{0}} 個', {0: number_format(max_options)})
				};
			}
			//console.log(`validator`, validator);

			fv.addField(`${fieldname}[]`, validator);
		}
	}, [fv]);

	// useEffect(() => { // to be updated after render
	// 	console.log(`checkedValues`, checkedValues);
	// }, [checkedValues]);

	switch (displayMode) {
		case '1R1O':
		case '1RMO':
			return (
				<CB1R1O
					lang={props.lang}
					form_component={{...form_component, options: optionList, option_display: displayMode}}
					checkedValues={checkedValues}
					formFields={formFields}
				/>
			);

		case 'OW':
			return (
				<CBOW
					lang={props.lang}
					form_component={{...form_component, options: optionList, option_display: displayMode}}
					checkedValues={checkedValues}
					formFields={formFields}
				/>
			);

		default:
			return (
				<CB1R1O
					lang={props.lang}
					form_component={{...form_component, options: optionList, option_display: '1R1O'}}
					checkedValues={checkedValues}
					formFields={formFields}
				/>
			);
	}
}

export default Checkbox;